export const getLocalRedirectPath = (path: string | null | undefined) => {
    if (!path || !path.startsWith("/") || path.startsWith("//")) {
        return null;
    }

    return path;
};

export const toLocalPath = (path: string | null | undefined) => {
    if (!path) {
        return "/";
    }

    return path.startsWith("/") ? path : `/${path}`;
};

export const getLoginHref = (from: string | null | undefined) => {
    return `/login?from=${encodeURIComponent(toLocalPath(from))}`;
};
